import React from 'react';

const Experience = () => {
  return (
    <div>
      <h2 style={{ marginTop: 0, color: '#333' }}>Werkervaring</h2>
      <div style={{ marginBottom: '2rem' }}>
        <h3>Frontend Developer</h3>
        <p style={{ color: '#666', marginBottom: '0.5rem' }}>2025 - Heden</p>
        <p>Profource ervaring met:</p>
        <ul>
          <li>Oracle BI Publisher</li>
          <li>Oracle rapportages</li>
          <li>SQL Query's</li>
          <li>Playwright</li>
          <li>Visual studio code</li>
          <li>Agile methodologie voor stand-ups en springplanning</li>
          <li>Postman</li>
        </ul>
      </div>
      <div style={{ marginBottom: '2rem' }}>
        <h3>Business Central Developer</h3>
        <p style={{ color: '#666', marginBottom: '0.5rem' }}>2021 - 2025</p>
        <p>Mysolution Business Central Developer ervaring met:</p>
        <ul>
          <li>Microsoft ERP systeem Dynamics 365 Business Central</li>
          <li>AL code (Application Language)</li>
          <li>Visual studio code</li>
          <li>Azure DevOps voor gezamenlijke ontwikkeling</li>
          <li>Agile methodologie voor stand-ups en springplanning</li>
        </ul>
      </div>
      <div>
        <h3>Medewerker Salaris Administratie</h3>
        <p style={{ color: '#666', marginBottom: '0.5rem' }}>2017 - 2021</p>
        <p>IRS Salaris Rijswijk, ervaring met:</p>
        <ul>
          <li>Unit4 systeem</li>
          <li>Excel rapportages</li>
        </ul>
      </div>
    </div>
  );
};

export default Experience;
